/* eslint-disable @typescript-eslint/no-explicit-any */

// Ortam damgası build sırasında gömülür: .env → Dev · .env.test → Test · .env.prod → Prod.
// Backend'deki karşılığı AppSettings.Ortam + IOrtamProvider (Server.Business/Providers/OrtamProvider.cs);
// iki taraf ayrı beslenir, bu yüzden ikisi de aynı fail-safe kuralı uygular: gevşetme YALNIZ açıkça
// tanınan "Dev"/"Test" değerlerinde olur, damga boş/yanlışsa PROD gibi davranılır.
//
// NOT: isTest() farklı bir şeye bakar (window.KRCNVERSION damgası) ve o damga bugün imaja hiç girmiyor
// → isTest() canlıda daima false. Ortam kararı için isGelistirmeOrtami() kullan, isTestOrDev()'i değil.
const ORTAM_DEV = "dev";
const ORTAM_TEST = "test";

const EnvironmentHelper = {
    GlobalMainEndpoint: (): string => ((window as any).KRCNMAINENDPOINT ?? process.env.REACT_APP_BFF_API_URL) ?? "",
    GlobalAppVersion: (): string => (window as any).KRCNVERSION ?? "Development",
    Ortam: (): string => process.env.REACT_APP_ORTAM ?? "",
    isTest: () => EnvironmentHelper.GlobalAppVersion().endsWith("-test"),
    isDev: () => EnvironmentHelper.GlobalMainEndpoint().indexOf("localhost") > -1,
    isTestOrDev: () => EnvironmentHelper.isTest() || EnvironmentHelper.isDev(),

    /** Açıkça tanınan bir geliştirme ortamı mı (Dev/Test)? Damga boş/bilinmiyorsa false. */
    isGelistirmeOrtami: () => {
        const ortam = EnvironmentHelper.Ortam().toLowerCase();
        return ortam === ORTAM_DEV || ortam === ORTAM_TEST;
    },

    /** Parola politikası zorlansın mı? Dev/Test'te gerçek kullanıcı olmadığı için kapalıdır. */
    parolaPolitikasiZorunluMu: () => !EnvironmentHelper.isGelistirmeOrtami(),
}

export default EnvironmentHelper;